<template>
  <a-card :bordered="true">
    <!-- 表格内容操作 start -->
    <!-- <div class="table-operator">
      <a-button type="primary" style="margin-right:15px;">全部导出</a-button>
      <a-button type="dashed" @click="toggleTableAlert()">{{ optionAlertShow && '关闭' || '开启' }}多选</a-button>
      <a-dropdown v-if="optionAlertShow && selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1"><a-icon type="file-zip" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div> -->
    <!-- 表格内容操作 end -->
    <a-tabs default-active-key="1" v-model="activeKey">
      <a-tab-pane key="1" tab="待上课">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit1">
            <a-row :gutter="48">
              <!-- 输入关键词查找 -->
              <a-col :md="6" :sm="24">
                <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入老师名称搜索" v-model="queryParam1.tname"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24" style="padding-right:0px;">
                <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker @change="onDateChange" />
                </a-form-item>
              </a-col>
              <template v-if="advanced">
              </template>
              <!-- 展开或者收起筛选项 start -->
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">查询</a-button>
                  <a-button style="margin-left: 8px" @click="reset1">重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
              <!-- 展开或者收起筛选项 end -->
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          :scroll="{ x: 2000 }"
          ref="table1"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData1"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.teacher_data.qq }}
          </span>
          <span slot="times" slot-scope="text, record">
            <span v-if="record.ctype === '菲教'">{{ record.class_time || '--' }}-{{ record.end_time }}</span>
            <span v-if="record.ctype !== '菲教'">{{ record.times || '--' }}</span>
          </span>
          <span slot="meeting_number" slot-scope="text, record">
            {{ record.meeting_number }}
          </span>
          <span slot="report" slot-scope="text, record">
            <a v-if="text" :href="record.report" target="_blank">下载报告</a>
            <span v-if="!text">--</span>
          </span>
          <span slot="kjpath" slot-scope="text, record">
            <a v-if="text" :href="record.kjpath" target="_blank">{{ record.ware_title || '课件' }}</a>
            <span v-if="!text">暂无课件</span>
            <a-icon style="margin-left:10px;font-size:18px;" title="点击上传课件" type="upload" @click="showKjpathModal(record)"/>
          </span>
          <span slot="status">
            未上课
          </span>
          <span slot="topic" slot-scope="text, record">
            <p style="line-height:100%;" v-for="(topic, index) in record.topic" :key="index">{{ topic.p_title }}:{{topic.title}}</p>
            <a @click="showTopicModal(record)">上课话题</a>
          </span>
          <span slot="topic_progress" slot-scope="text, record">
            <a @click="showProgress(record)" title="点击查看学习进度">点击查看</a>
          </span>
          <span slot="teacher_point" slot-scope="text">
            <span v-if="text !== 0">{{ text }}</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a-popconfirm
              title="确定取消预约（开课前3小时以内取消，需要扣0.5课时补偿给老师）"
              @confirm="handleCancelOk(record.sub_id)"
              okText="确认"
              cancelText="取消"
            >
              <a href="#">取消预约</a>
            </a-popconfirm>
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="2" tab="已完成">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit2">
            <a-row :gutter="48">
              <!-- 输入关键词查找 -->
              <a-col :md="6" :sm="24">
                <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入老师名称搜索" v-model="queryParam2.tname"></a-input>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
              </template>
              <!-- 展开或者收起筛选项 start -->
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">查询</a-button>
                  <a-button style="margin-left: 8px" @click="reset2">重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
              <!-- 展开或者收起筛选项 end -->
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          :scroll="{ x: 2000 }"
          ref="table2"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData2"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.teacher_data.qq }}
          </span>
          <span slot="times" slot-scope="text, record">
            <span v-if="record.ctype === '菲教'">{{ record.class_time || '--' }}-{{ record.end_time }}</span>
            <span v-if="record.ctype !== '菲教'">{{ record.times || '--' }}</span>
          </span>
          <span slot="meeting_number" slot-scope="text, record">
            {{ record.meeting_number }}
          </span>
          <span slot="report" slot-scope="text, record">
            <a v-if="text" :href="record.report" target="_blank">下载报告</a>
            <span v-if="!text">--</span>
          </span>
          <span slot="kjpath" slot-scope="text, record">
            <a v-if="text" :href="record.kjpath" target="_blank">{{ record.ware_title || '课件' }}</a>
            <span v-if="!text">暂无课件</span>
            <a-icon style="margin-left:10px;font-size:18px;" title="点击上传课件" type="upload" @click="showKjpathModal(record)"/>
          </span>
          <span slot="status">
            已完成
          </span>
          <span slot="topic_progress" slot-scope="text, record">
            <a @click="showProgress(record)" title="点击查看学习进度">点击查看</a>
          </span>
          <span slot="topic" slot-scope="text, record">
            <p style="line-height:100%;" v-for="(topic, index) in record.topic" :key="index">{{ topic.p_title }}:{{topic.title}}</p>
          </span>
          <span slot="teacher_point" slot-scope="text">
            <span v-if="text !== 0">{{ text }}</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a v-if="record.teacher_point===0" @click="showEvaluateModal(record)">老师评价</a>
            <span v-if="record.teacher_point!==0">--</span>
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="3" tab="已取消">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit3">
            <a-row :gutter="48">
              <!-- 输入关键词查找 -->
              <a-col :md="6" :sm="24">
                <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入老师名称搜索" v-model="queryParam3.tname"></a-input>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
              </template>
              <!-- 展开或者收起筛选项 start -->
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">查询</a-button>
                  <a-button style="margin-left: 8px" @click="reset3">重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
              <!-- 展开或者收起筛选项 end -->
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          :scroll="{ x: 2000 }"
          ref="table3"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData3"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.teacher_data.qq }}
          </span>
          <span slot="times" slot-scope="text, record">
            <span v-if="record.ctype === '菲教'">{{ record.class_time || '--' }}-{{ record.end_time }}</span>
            <span v-if="record.ctype !== '菲教'">{{ record.times || '--' }}</span>
          </span>
          <span slot="meeting_number" slot-scope="text, record">
            {{ record.meeting_number }}
          </span>
          <span slot="report" slot-scope="text, record">
            <a v-if="text" :href="record.report" target="_blank">下载报告</a>
            <span v-if="!text">--</span>
          </span>
          <span slot="kjpath" slot-scope="text, record">
            <a v-if="text" :href="record.kjpath" target="_blank">{{ record.ware_title || '课件' }}</a>
            <span v-if="!text">暂无课件</span>
            <a-icon style="margin-left:10px;font-size:18px;" title="点击上传课件" type="upload" @click="showKjpathModal(record)"/>
          </span>
          <span slot="status">
            已取消
          </span>
          <span slot="topic_progress" slot-scope="text, record">
            <a @click="showProgress(record)" title="点击查看学习进度">点击查看</a>
          </span>
          <span slot="topic" slot-scope="text, record">
            <p style="line-height:100%;" v-for="(topic, index) in record.topic" :key="index">{{ topic.p_title }}:{{topic.title}}</p>
          </span>
          <span slot="teacher_point" slot-scope="text">
            <span v-if="text !== 0">{{ text }}</span>
          </span>
          <span slot="action">
            --
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
    </a-tabs>
    <a-modal :confirm-loading="confirmLoading" v-if="editMnVisible" :visible="editMnVisible" title="会议号更新" @ok="handleMnOk" @cancel="editMnVisible = false">
      <a-input v-model="editMnData.meeting_number" placeholder="请输入会议号" />
    </a-modal>
    <a-modal :confirm-loading="confirmLoading" v-if="kjpathVisible" :visible="kjpathVisible" title="上传课件" @ok="handleKjpathOk" @cancel="kjpathVisible = false">
      <a-upload
        name="file"
        :multiple="false"
        list-type="text"
        action="/index.php/upload_file/uploadFile?type=studentkj"
        @change="handleKjpathChange"
      >
        <a-button><a-icon type="upload" />点击上传课件</a-button>
      </a-upload>
    </a-modal>
    <a-modal :confirm-loading="confirmLoading" v-if="evaluateVisible" :visible="evaluateVisible" title="老师评价" @ok="handleEvaluateOk" @cancel="evaluateVisible = false">
      评分：<a-rate v-model="evaluateData.teacher_point" />
      <br />
      <br />
      <a-textarea style="display:inline-block" v-model="evaluateData.evaluate" placeholder="请填写评价" :rows="4" />
    </a-modal>
    <!-- 学习进度 -->
    <a-modal v-if="progressVisible" :visible="progressVisible" title="学习进度" @ok="progressVisible=false" @cancel="progressVisible = false">
      <p style="font-size:16px;font-weight:bold;">课程名称：{{ nowCname }}</p> 
      <div v-for="(topic, index) in progressData.detailList" :key="index" style="margin-top:20px;">
        <span style="font-size:16px;">{{ topic.pid | valInDict(topicDict)  }}</span> : <span>{{ topic.title }}</span><span v-if="topic.is_new==='YES'" style="color:red;">（NEW）</span><span v-if="topic.checked==='NO'" style="color:red;">（待学习）</span><span v-if="topic.checked==='YES'" style="color:yellow">（已上课）</span>
        <span v-for="(time, i) in topic.times" :key="i">
          <a-icon type="check-circle" style="font-size:14px;color:yellow;margin-left:20px;"/><span style="margin-left:10px;font-size:12px;">{{ time }}</span>
        </span>
      </div>
    </a-modal>
    <!-- 上课话题 -->
    <a-modal width="800px" :confirm-loading="confirmLoading" v-if="topicVisible" :visible="topicVisible" title="上课话题" @ok="handleTopicOk" @cancel="topicVisible = false">
      选择教材：<a-select
          style="width:300px;"
          :allowClear="true"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="handleMaterialChange"
          v-model="topicData.mat_id"
          placeholder="请输入搜索选择教材">
          <a-select-option :value=0>请选择教材</a-select-option>
          <a-select-option v-for="item in materialDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      <br />
      <br />
      选择话题：<a-select
          style="width:650px;"
          mode="multiple"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          v-model="topicData.topic"
          placeholder="请输入搜索选择话题，可多选">
          <a-select-option v-if="item.type === 'TOPIC' && item.pid !== 0" v-for="item in wareDict" :key="item.detail_id" :value="item.detail_id">{{ item.pid | valInDict(topicDict) }} : {{ item.title }}</a-select-option>
        </a-select>
    </a-modal>
  </a-card>
</template>
<script>
import { getPre, getList, saveMn, saveKjpath, saveEvaluate, saveCancel, checkProgress, saveTopic } from '@/api/subscribe'
import { getDictByCourse } from '@/api/orders'
import { getDetailList } from '@/api/material'
import { TcgTable } from '@/components'
import notification from 'ant-design-vue/es/notification'
import _ from 'lodash'

export default {
  components: {
    TcgTable
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // id
      id: '',
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam1: {
        status: 'WAIT',
        tname: ''
      },
      queryParam2: {
        status: 'DONE',
        tname: ''
      },
      queryParam3: {
        status: 'CANCEL',
        tname: ''
      },
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          width: '80px'
        },
        {
          title: '旺旺名',
          dataIndex: 'uname',
          width: '120px'
        },
        {
          title: '日期',
          dataIndex: 'days',
          sorter: true,
          width: '100px'
        },
        {
          title: '时间',
          dataIndex: 'times',
          scopedSlots: { customRender: 'times' },
          sorter: true,
          width: '100px'
        },
        {
          title: '课程名称',
          dataIndex: 'cname',
          scopedSlots: { customRender: 'cname' },
          width: '150px'
        },
        {
          title: '老师',
          dataIndex: 'teacher',
          scopedSlots: { customRender: 'teacher' },
          width: '100px'
        },
        {
          title: '联系方式',
          dataIndex: 'qq',
          scopedSlots: { customRender: 'qq' },
          width: '150px'
        },
        {
          title: '会议号',
          dataIndex: 'meeting_number',
          scopedSlots: { customRender: 'meeting_number' },
          width: '120px'
        },
        {
          title: '话题进度',
          dataIndex: 'topic_progress',
          scopedSlots: { customRender: 'topic_progress' },
          width: '100px'
        },
        {
          title: '本节话题',
          dataIndex: 'topic',
          scopedSlots: { customRender: 'topic' },
          width: '200px'
        },
        {
          title: '课件',
          dataIndex: 'kjpath',
          scopedSlots: { customRender: 'kjpath' },
          width: '100px'
        },
        {
          title: '报告',
          dataIndex: 'report',
          scopedSlots: { customRender: 'report' },
          width: '100px'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          width: '100px'
        },
        {
          title: '老师得分',
          dataIndex: 'teacher_point',
          scopedSlots: { customRender: 'teacher_point' },
          width: '100px'
        },
        {
          title: '评价内容',
          dataIndex: 'evaluate',
          scopedSlots: { customRender: 'evaluate' },
          width: '150px'
        },
        {
          title: '操作',
          dataIndex: 'sub_id',
          fixed: 'right',
          key: 'action',
          scopedSlots: { customRender: 'action' },
          width: '100px'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData1: parameter => {
        return getList(Object.assign(parameter, this.queryParam1))
          .then(res => {
            return res
          })
      },
      loadData2: parameter => {
        return getList(Object.assign(parameter, this.queryParam2))
          .then(res => {
            return res
          })
      },
      loadData3: parameter => {
        return getList(Object.assign(parameter, this.queryParam3))
          .then(res => {
            return res
          })
      },
      editMnVisible: false,
      editMnData: {},
      confirmLoading: false,
      kjpathVisible: false,
      kjpathData: {
        sub_id: 0,
        report: ''
      },
      evaluateVisible: false,
      evaluateData: {
        teacher_point: 5,
        evaluate: ''
      },
      nowCname: '',
      progressVisible: false,
      progressData: {
        detailList: [],
        progressList: []
      },
      topicDict: [],
      activeKey: '1',
      topicVisible: false,
      topicData: {
        sub_id: '',
        mat_id: '',
        topic: []
      },
      materialDict: [],
      wareDict: [],
      wareData: {
        sub_id: '',
        mat_id: '',
        ware_id: '',
        wate_title: '',
        kjpath: '',
        kjUrl: ''
      }
    }
  },
  created () {
    // this.handelPre()
  },
  methods: {
    // handelPre () {
    //   getPre().then(res => {
    //     if (_.get(res, 'code') === 200) {
    //       this.dict.statusDict = _.get(res, 'values.statusDict', [])
    //     }
    //   })
    // },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleEvaluateOk () {
      this.confirmLoading = true
      saveEvaluate(this.evaluateData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.confirmLoading = false
          this.$refs.table2.refresh(true)
          this.evaluateVisible = false
          notification.success({
            message: '评价成功',
            description: '保存成功'
          })
        } else {
          this.confirmLoading = false
          notification.warning({
            message: '评价失败',
            description: '请稍后再试'
          })
        }
      })
    },
    onDateChange(date, dateString) {
      this.queryParam1.startTime=dateString[0]
      this.queryParam1.endTime=dateString[1]
      this.$refs.table1.refresh(true)
    },
    handleMaterialChange (value) {
      this.wareDict = []
      this.wareData.ware_id = ''
      this.wareData.mat_id = value
      getDetailList({ mat_id: this.wareData.mat_id, size: 1000 }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.wareDict = _.get(res, 'data', [])
          this.topicDict = _.get(res, 'values.topicDict', [])
        }
      })
    },
    showTopicModal (record) {
      // 根据课程id获取教材列表 及 话题列表
      getDictByCourse({ cid: record.cid, order_id: record.order_id }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.materialDict = _.get(res, 'values.materialDict', [])
        }
      })
      if (record.mat_id !== 0) {
        getDetailList({ mat_id: record.mat_id, size: 1000, type: 'TOPIC', order_by: 'pid ASC, detail_id DESC' }).then(res => {
          if (_.get(res, 'code') === 200) {
            this.wareDict = _.get(res, 'data', [])
            this.topicDict = _.get(res, 'values.topicDict', [])
          }
        })
      }
      this.topicData.sub_id = record.sub_id
      this.topicData.mat_id = record.mat_id
      let topicArr = []
      const topic = record.topic
      topic.forEach((item) => {
        topicArr.push(item.detail_id)
      })
      this.topicData.topic = topicArr
      this.topicVisible = true
    },
    showKjpathModal (record) {
      this.kjpathVisible = true
      this.kjpathData = {
        sub_id: record.sub_id,
        report: ''
      }
    },
    showEvaluateModal (record) {
      this.evaluateVisible = true
      this.evaluateData = {
        sub_id: record.sub_id,
        teacher_point: 5,
        evaluate: record.evaluate
      }
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const fileUrl = _.get(info.file, 'response.data.url')
        this.kjpathData.kjpath = path
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleKjpathChange (info) {
      this.handleFileUpload(info, 'kjpath')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleKjpathOk () {
      if (this.kjpathData.kjpath === '') {
        this.$message.warning('请上传课件')
        return false
      }
      this.confirmLoading = true
      saveKjpath(this.kjpathData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.confirmLoading = false
          if (this.activeKey === '1') {
            this.$refs.table1.refresh(true)
          }
          if (this.activeKey === '2') {
            this.$refs.table2.refresh(true)
          }
          if (this.activeKey === '3') {
            this.$refs.table3.refresh(true)
          }
          this.kjpathVisible = false
          notification.success({
            message: '更新成功',
            description: '保存成功'
          })
        } else {
          this.confirmLoading = false
          notification.warning({
            message: '更新失败',
            description: '请稍后再试'
          })
        }
      })
    },
    // 开启更多查询方式
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 重置按钮
    reset1 () {
      this.queryParam1.tname = ''
      this.$refs.table1.refresh(true)
    },
    // 重置按钮
    reset2 () {
      this.queryParam2.tname = ''
      this.$refs.table2.refresh(true)
    },
    // 重置按钮
    reset3 () {
      this.queryParam3.tname = ''
      this.$refs.table3.refresh(true)
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id) {
      this.id = id
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 提交筛选
    handleSubmit1 (e) {
      e.preventDefault()
      this.$refs.table1.refresh(true)
    },
    handleSubmit2 (e) {
      e.preventDefault()
      this.$refs.table2.refresh(true)
    },
    handleSubmit3 (e) {
      e.preventDefault()
      this.$refs.table3.refresh(true)
    },
    // 切换提示
    toggleTableAlert () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    // 表格选择
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 批量操作按钮事件
    handleMenuClick (e) {
      if (e.key === '1') {
        const arrImages = []
        for (const i in this.selectedRows) {
        }
      }
    },
    handleCancelOk (subId) {
      saveCancel({ sub_id: subId }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.$refs.table1.refresh(true)
          this.$refs.table3.refresh(true)
        }
      })
    },
    showProgress (record) {
      this.nowCname = record.cname
      // 查询学习进度
      checkProgress({ sub_id: record.sub_id }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.progressData = _.get(res, 'data', {})
          this.topicDict = _.get(res, 'values.topicDict', [])
        }
      })
      this.progressVisible = true
    },
    handleTopicOk () {
      this.confirmLoading = true
      saveTopic(this.topicData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$refs.table1.refresh()
          this.confirmLoading = false
          this.topicVisible = false
          this.$message.success('操作成功')
        } else {
          this.confirmLoading = false
          this.$message.error('操作失败')
        }
      })  
    }
  }
}
</script>
<style lang="less" scoped>
</style>
